export const DD_MM_YYYY = 'dd/MM/yyyy'; // 28/07/2020
export const YYYY_MM_DD = 'yyyy-MM-dd'; // 2020-12-31
export const DD_MMM = 'dd MMM'; // 12 June
export const DO_MMM = 'do MMM'; // 12th June
export const MESSAGES_DATE_TIME = 'dd MMM, yyyy | h:mm a';
export const DO_MMM_YYYY = 'do MMM yyyy'; // 13th June 1991
export const DD_MMM_YYYY = 'do MMM yyyy'; // 13 June 1991
export const TIMELINE_DATE_TIME = 'ccc do MMM, h:mm a'; // Mon 12th Jun, 9:53 PM
export const DATE_TIME = 'do MMM, h:mm a'; // 12th Jun, 9:53 PM
export const REGULAR_TIME_FORMAT = 'h:mm a'; // 8:27 AM
export const CLAIM_TIMELINE_FORMAT = 'dd-MMM-yyyy';
export const REPAIR_TIME_FORMAT = 'do MMM yyyy, hh:mm aaa'; // 15th feb 2022, 3:00 PM
